<template>
    <div class="category-section">
        <h3 class="category-heading">{{ section.title }}<b-tag rounded class="ml-3">{{ section.count }}</b-tag></h3>
        <catalog-course
            class="mb-5"
            :course="course"
            v-for="course in section.courses"
            :key="'course-' + course.id"
            :details="false"
            @enroll="$emit('enroll', $event)"
        />
        <div class="child-section" v-for="child in section.children" :key="'child-' + child.id">
            <h4 class="category-heading">{{ child.title }}<b-tag rounded class="ml-3">{{ child.count }}</b-tag></h4>
            <catalog-course
                class="mb-5"
                :course="course"
                v-for="course in child.courses"
                :key="'child-course-' + child.id + '-' + course.id"
                :details="false"
                @enroll="$emit('enroll', $event)"
            />
        </div>
    </div>
</template>

<script>
    import CatalogCourse from "../CatalogCourse";

    export default {
        name: "CatalogCategorySection",
        components: {CatalogCourse},
        props: ['section']
    };
</script>

<style lang="scss" scoped>
    .category-section {
        margin-bottom: 2.5rem;

        h3.category-heading {
            font-size: 1rem;
            font-weight: bold;
            color: white;
            margin-bottom: 1.25rem;
        }

        .child-section {
            margin-left: 1.5rem;

            h4.category-heading {
                font-size: 0.9rem;
                font-weight: bold;
                color: white;
                margin-bottom: 1.25rem;
            }
        }
    }
</style>
